<template>
  <div>
    <h3 class="color-darkblue">Claim</h3>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <label class="control-label require">Servicing Location:</label>
        <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text"
          :options="locationArr">
        </v-select>
        <div class="field-error">{{ location_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require" for="code">Claim Reference #:</label>
        <input type="text" class="form-control" :disabled="true" v-model="claim_number" id="code"
          placeholder="Enter Claim Number" name="claim_number">
        <div class="field-error">{{ claim_number_error_msg }}</div>
      </div>
      <div class="col form-group">
        <label class="control-label require">Claim Type:</label>
        <v-select class="close-remove" v-model="claim_type" id="claim_type" name="claim_type"
          placeholder="Select Claim Type" label="text" :options="claimTypeArr">
        </v-select>
        <div class="field-error">{{ claim_type_error_msg }}</div>
      </div>

      <div class="col form-group" v-if="show_campaign_number">
        <label class="control-label">Field Fix Campaign #:</label>
        <input type="text" v-model="field_fix_campaign_number" class="form-control"
          placeholder="Enter Field Fix Campaign #" name="field_fix_campaign_number" id="field_fix_campaign_number" />
      </div>

      <div class="col form-group">
        <label class="control-label">Based on:</label>
        <v-select class="close-remove" v-model="based_on" id="based_on" name="based_on"
          placeholder="Based On" label="text" :options="basedOnArr">
        </v-select>
        <div class="field-error">{{ based_on_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Vin#:</label>
        <v-select v-model="product_sn" id="product_sn" name="product_sn" label="text" :filterable="false"
          :options="vinArr" @search="onSearchAssetWithVin" placeholder="Search Vehicle with Vin"
          class='custom-ci-auto-search close-remove'>
          <template slot="no-options">
            Search Vehicle with Vin...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ product_sn_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label">Service Bulletin:</label>
        <input type="text" v-model="service_bulletin" class="form-control" placeholder="Enter Service Bulleting"
          name="service_bulleting" id="service_bulleting" />
        <div class="field-error">{{ service_bulleting_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label for="wty_agreement" class="control-label">Wty Agreement Customer
          Repair:</label>
        <input type="checkbox" v-model="wty_agreement" name="wty_agreement" id="wty_agreement" />
      </div>

      <div class="col form-group">
        <label class="control-label require">Odometer or Hour Meter Reading:</label>
        <input type="number" v-model="repair_distance" class="form-control" placeholder="Enter Repair Distance"
          name="repair_distance" id="repair_distance" />
        <div class="field-error">{{ repair_distance_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Repair Order # / Job Card #:</label>
        <input type="text" v-model="repair_order" class="form-control" placeholder="Enter Repair Order"
          name="repair_order" id="repair_order" />
        <div class="field-error">{{ repair_order_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label v-if="require_pwa_auth" class="control-label require">PWA Auth#:</label>
        <label v-else class="control-label">PWA Auth#:</label>

        <input type="text" v-model="authorization_number" class="form-control" placeholder="Enter Authorization Number"
          name="authorization_no" id="authorization_no" />
        <div class="field-error">{{ authorization_number_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Claim Date:</label>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="claim_date" name="claim_date" v-model="claim_date"
            :config="optionsDate"></date-picker>
          <label for="claim_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ claim_date_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Created by:</label>
        <input type="text" v-model="created_by" class="form-control" name="created_by" id="created_by" disabled />
      </div>


      <div class="col form-group">
        <label class="control-label">VEV Support Ticket#:</label>
        <input type="text" v-model="wsc_ticket_no" class="form-control" placeholder="Enter Wsc Ticket Number"
          name="wsc_ticket" id="wsc_ticket" />
        <div class="field-error">{{ wsc_ticket_no_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label">Currency:</label>
        <input type="text" v-model="currency" class="form-control" name="currency" id="currency" disabled />
      </div>

    </div>
    <!-- Comments -->
    <div class="order-summary mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="bg-white radius-5 p-3">
            <h3>Comments</h3>
            <warranty-claim-comment ref="claimComment"
              @send-comment-data-claim-tab="handleCommentData"></warranty-claim-comment>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-groups mt-3">
      <button type="button"
        v-on:click="updateFormSection()" class="btn btn-primary">
        <i class="fp-edit"></i> Edit
      </button>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import WarrantyClaimComments from './WarrantyClaimComments.vue';
import { contractMixins } from "../../mixins/contractMixins";
import { commonMixins } from "../../mixins/commonMixins";


Vue.component("warranty-claim-comment", WarrantyClaimComments);

export default {
  name: "EvClaimFormSection",
  props: ['claimTabData','claimId','hideEditSection'],
  mixins: [commonMixins, contractMixins],
  data: () => ({
    locationArr: [],
    claimTypeArr: [],
    vinArr: [],
    commentArr: [],
    basedOnArr: ["Pre-approval", "Previous Claim", "Template"],
    location_id: null,
    location_error_msg: "",
    claim_number: null,
    claim_number_error_msg: "",
    claim_type: null,
    claim_type_error_msg: "",
    show_campaign_number: false,
    field_fix_campaign_number: null,
    based_on: null,
    based_on_error_msg: "",
    product_sn: null,
    product_sn_error_msg: "",
    service_bulletin: null,
    service_bulleting_error_msg: "",
    wty_agreement: null,
    repair_distance: null,
    repair_distance_error_msg: null,
    repair_order: null,
    repair_order_error_msg: null,
    require_pwa_auth: false,
    authorization_number: null,
    authorization_number_error_msg: "",
    claim_date: null,
    optionsDate: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
    },
    claim_date_error_msg: "",
    created_by: null,
    wsc_ticket_no: null,
    wsc_ticket_no_error_msg: "",
    currency: null,
    vehicle_id: null,
  }),
  created() {
    this.populateData();
  },
  watch: {
    claim_number: function(claim_number){
      var self = this;
      if(claim_number != "" || claim_number != null){
        this.$refs.claimComment.getCommentsFromClaimNumber(self.claim_number);
      }
    },
    claimTypeArr: function (claimTypeArr) {
      var self = this;
      if (claimTypeArr.length > 0) {
        for (const element of claimTypeArr) {
          if(element.code == 'warranty'){
            self.claim_type = element;
            break;
          }
        }
      }
    },
    claim_type: function(claim_type){
      var self = this;
      if(claim_type.code == "field_fix_recall"){
        self.show_campaign_number = true;
      }else{
        self.show_campaign_number = false;
      }
      if(claim_type.code == "goodwill_policy"){
        self.require_pwa_auth = true;
      }else{
        self.require_pwa_auth = false;
      }
    },
    product_sn: function (product_sn) {
      var self = this;
      self.vehicle_id = self.product_sn;
    },
  },
  mounted() {
    this.loadFieldData(['location', 'ev_claim_types']);
  },
  methods: {
    handleCommentData(commentData) {
      var self = this;
      self.commentArr = commentData;
    },
    onSearchAssetWithVin(search, loading) {
      var self = this;
      if (search.length > 3) {
        loading(true);
        self.searchField(loading, search, 'vehicle_vin', '');
      }
    },
    populateData() {
      this.location_id = {"text": this.claimTabData.submit_location_text,"value": this.claimTabData.submitting_location_id};
      this.claim_number = this.claimTabData.claim_number;
      this.claim_type = {"text": this.claimTabData.claim_type_text,"value": this.claimTabData.claim_type};
      // this.show_campaign_number = this.claimTabData;
      this.field_fix_campaign_number = this.claimTabData.fix_campaign_number;
      this.based_on = this.claimTabData.based_on;
      this.product_sn = this.claimTabData.product_sn;
      this.service_bulletin = this.claimTabData.service_bulletin;
      if (this.claimTabData.wty_agreement_customer_repair == "yes") {
        self.wty_agreement = true;
      } else {
        self.wty_agreement = false;
      }
      this.repair_distance = this.claimTabData.repair_distance;
      this.repair_order = this.claimTabData.repair_order;
      // this.require_pwa_auth = this.claimTabData.;
      this.authorization_number = this.claimTabData.authorization_number;
      this.claim_date = this.claimTabData.claim_date;
      this.created_by = this.claimTabData.created_by_user;
      this.wsc_ticket_no = this.claimTabData.wsc_ticket_no;
      this.currency = this.claimTabData.currency;
      // this.$refs.claimComment.getCommentsFromClaimNumber(this.claim_number);
    },

    updateFormSection(){
      var self = this;
      const sectionData = this.prepareDataForUpdating();
      self.$parent.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/update/calim-form-section",
          type: "POST",
          data: {
            formSectionData: sectionData,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          cors: true,
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              console.log("DATAAA");
              self.hideEditSection("claim_form_section");
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
    },
    prepareDataForUpdating(){
      if(this.commentArr.length == 0){
        var commentArray = "";
      }else{
        var commentArray = this.commentArr;
      }
      const dataToSend = {
        submitting_location: this.location_id,
        claim_number: this.claim_number,
        // request_type: this.request_type,
        claim_type: this.claim_type,
        based_on: this.based_on,
        product_sn: this.product_sn,
        asset: this.vehicle_id,
        service_bulletin: this.service_bulletin,
        wty_agreement: this.wty_agreement,
        repair_distance: this.repair_distance, // odometer or hour meter Reading.
        repair_order: this.repair_order,
        authorization_number: this.authorization_number, // pwa auth
        // supplier_authorization_number: this.supplier_authorization_number,
        // supplier_additional_info: this.supplier_additional_info,
        claim_date: this.claim_date,
        created_by: this.created_by,
        wsc_ticket_no: this.wsc_ticket_no,
        currency: this.currency,
        comment: this.comment,
        commentArr: commentArray,
        fix_campaign_number: this.field_fix_campaign_number,
        claimId: this.claimId,
      };
      return dataToSend;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvClaimFormSection.vue